// extracted by mini-css-extract-plugin
module.exports = {"tablet-small":"768px","container":"doc-feedback-prompt_container__E7_8O"};